import { render, staticRenderFns } from "./BeauticianActions.vue?vue&type=template&id=3b0e82ff&scoped=true"
import script from "./BeauticianActions.vue?vue&type=script&lang=js"
export * from "./BeauticianActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e82ff",
  null
  
)

export default component.exports